export default "__VITE_ASSET__BO7dCpfB__$_?nuxt_component=async&nuxt_component_name=SvgoTradingOtcSettlementIcon&nuxt_component_export=default__"